import { createSlice } from '@reduxjs/toolkit';

import type { CartItemState } from '../../structureDefinitions/cartState';

import { setFullCart } from './cartHydrationActions';

const cartEditedOrderItemsSlice = createSlice({
    name: 'editedOrderItems',
    initialState: [] as CartItemState[],
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setFullCart, (_state, action) => action.payload.editedOrderItems);
    },
});

export const { actions: cartEditedOrderItemsActions, reducer: cartEditedOrderItemsReducer } =
    cartEditedOrderItemsSlice;
